"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var SelectPart_1;
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectPart = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const _part_includes_1 = require("../_part_includes");
//@ts-ignore                
let rwsTemplate = T.html `<div class="form-group has-float-label form-group rounded">
    ${(0, fast_element_1.when)(x => x.label, (0, fast_element_1.html) `<label part="label" class="form-label">${x => x.label.t()}</label>`)}
    <slot name="info"></slot>
    <select 
        part="select"
        name="${x => x.name}"
        class="form-control"
        ?required="${x => x.isRequired}"
        @change="${(x, c) => x.handleChange(c.event)}"
        ?multiple="${x => x.multiple}"        
        placeholder="${x => x.placeholder ? x.placeholder.t() : ''}"
    >
        
        ${(0, fast_element_1.repeat)(x => x.options || [], (0, fast_element_1.html) `
            <option 
                ?selected="${(x, c) => {
    if (c.parent.multiple) {
        return c.parent.value.includes(x.value);
    }
    // Handle both string and numeric comparisons
    return x.value === c.parent.value ||
        String(x.value) === String(c.parent.value) ||
        (x.value === null && (c.parent.value === null || c.parent.value === '' || c.parent.value === undefined));
}}" 
                value="${opt => opt.value ? opt.value : ''}">
                ${opt => opt.label.t()}
            </option>`)}
    </select>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host-context(.force-placeholder) input::placeholder,
select::placeholder,
textarea::placeholder {
  opacity: 1 !important;
}

.form-group.is-invalid label {
  color: var(--error_color) !important;
}
.form-group.is-invalid .form-control {
  border-color: var(--error_color) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
  color: var(--error_color) !important;
}

:host(.no-margin) .form-group {
  margin: 0 !important;
}

:host(.mini) .form-control {
  padding: 0.2rem 0.4rem;
  line-height: 0.8;
  font-size: 0.6rem;
}

:host(.rounded) .form-control {
  border-radius: 0.375rem;
}

.no-label {
  margin-left: 0;
}

.form-group.rounded .form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.92rem;
  font-weight: 700;
  position: relative;
  top: 0;
  left: 0;
}

.form-group.rounded select.form-control {
  border: 1px solid var(--brand-border, #e4e7ec);
  border-radius: 8px;
  color: var(--ink, #2f2f3a);
  background: #fff;
  font-size: 0.95rem;
  padding: 0.55rem 0.75rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  appearance: auto;
}

.form-group.rounded select.form-control:focus {
  border-color: var(--brand, #17b4a6);
  box-shadow: 0 0 0 0.2rem rgba(23, 180, 166, 0.2);
  outline: none;
}`;
const shadowOptions = { "mode": "open" };
let SelectPart = SelectPart_1 = class SelectPart extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.multiple = false;
        this.ignored = 'false';
        this.dontEmit = false;
        this.hoverevent = false;
        this.handleChange = (event) => {
            const target = event.target;
            _part_includes_1.handlePartChange.call(this, event);
            if (this.hoverevent) {
                const newValue = this.multiple
                    ? Array.from(target.selectedOptions).map((option) => option.value)
                    : target.value;
                const selectedValues = Array.isArray(newValue) ? newValue : [newValue];
                (this.options || []).forEach((option) => {
                    if (selectedValues.some((sv) => String(sv) === String(option.value))) {
                        this.$emit('form-part:option:hover', {
                            info: option.info,
                            label: option.label,
                            value: option.value,
                            name: this.name,
                            formPartType: SelectPart_1.PART_TYPE
                        });
                    }
                });
            }
        };
        this.hasEmittedInitialHover = false;
    }
    emitHoverForCurrentValue() {
        if (!this.hoverevent || this.hasEmittedInitialHover) {
            return;
        }
        const selectedValues = Array.isArray(this.value) ? this.value : [this.value];
        if (!selectedValues.length || (selectedValues.length === 1 && (selectedValues[0] === undefined || selectedValues[0] === '' || selectedValues[0] === null))) {
            return;
        }
        (this.options || []).forEach((option) => {
            if (selectedValues.some((sv) => String(sv) === String(option.value))) {
                this.$emit('form-part:option:hover', {
                    info: option.info,
                    label: option.label,
                    value: option.value,
                    name: this.name,
                    formPartType: SelectPart_1.PART_TYPE
                });
            }
        });
        this.hasEmittedInitialHover = true;
    }
    valueChanged(_oldValue, _newValue) {
        this.emitHoverForCurrentValue();
    }
    connectedCallback() {
        super.connectedCallback();
        this.emitHoverForCurrentValue();
    }
    requiredChanged(oldValue, newValue) {
        this.required = newValue;
        this.isRequired = this.required === 'true';
    }
    getElement() {
        return this.$('select');
    }
    reset() {
        this.$('select').value = null;
        (this.shadowRoot.querySelectorAll('option')).forEach((option) => {
            option.selected = false;
        });
    }
};
exports.SelectPart = SelectPart;
SelectPart.PART_TYPE = 'select';
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SelectPart.prototype, "label", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SelectPart.prototype, "name", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], SelectPart.prototype, "value", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof Array !== "undefined" && Array) === "function" ? _a : Object)
], SelectPart.prototype, "options", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], SelectPart.prototype, "multiple", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SelectPart.prototype, "required", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SelectPart.prototype, "placeholder", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SelectPart.prototype, "ignored", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], SelectPart.prototype, "dontEmit", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], SelectPart.prototype, "hoverevent", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SelectPart.prototype, "isRequired", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], SelectPart.prototype, "onChange", void 0);
exports.SelectPart = SelectPart = SelectPart_1 = __decorate([
    (0, client_1.RWSView)('part-select', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], SelectPart);
SelectPart.defineComponent();
